<template>
  <div id="errorAnalysis">
    <div
      style="
        margin-left: 25px;
        margin-top: 10px;
        padding: 5px;
        text-align: left;
      "
    >
      年份：
      <Select
        v-model="selectYear"
        style="width: 100px; margin-right: 20px"
        @on-change="changeYear"
      >
        <Option v-for="item in yearList" :value="item" :key="item">{{
          item
        }}</Option>
      </Select>

      台风选择：
      <Select
        v-model="selectTyphoon"
        style="width: 100px; margin-right: 20px"
        @on-change="changeTyphoon"
      >
        <Option
          v-for="item in typhoonList"
          :value="item.tfid"
          :key="item.tfid"
          >{{ item.name }}</Option
        >
      </Select>

      中大预报时间：
      <Select v-model="foreastingid" style="width: 200px; margin-right: 20px">
        <Option
          v-for="item in trackData"
          :value="item.currentId"
          :key="item.currentId"
          >{{ moment(item.time).format("YYYY-MM-DD HH:mm:ss") }}</Option
        >
      </Select>

      对比预报源：
      <Select
        v-model="selectYubaoType"
        style="width: 100px; margin-right: 20px"
      >
        <Option
          v-for="item in yubaoTypeList"
          :value="item.value"
          :key="item.value"
          >{{ item.name }}</Option
        >
      </Select>

      <button class="layui-btn layui-btn-normal" @click="getData">
        对比分析
      </button>
      <button class="layui-btn layui-btn-normal" @click="exportTable">
        导出表格
      </button>
    </div>
    <Table
      :columns="columns"
      :data="result"
      ref="analysisTable"
      width="100%"
      @on-select="remainRow"
      @on-select-cancel="remainRow"
      @on-select-all="remainRow"
    >
      <template slot-scope="{ row }" slot="time">
        {{ moment(row.time).format("YYYY-MM-DD HH:mm:ss") }}
      </template>
    </Table>
  </div>
</template>

<script type="text/ecmascript-6">
import moment from "moment";
import Weathermap from "@/map/weathermap.vue";
export default {
  components: {
    Weathermap,
  },
  data() {
    return {
      moment: moment,
      yearList: [],
      selectYear: Number(moment().format("YYYY")),
      typhoonList: [],
      selectTyphoon: "",
      trackData: [],
      foreastingid: "",
      yubaoTypeList: [
        {
          name: "实况",
          value: "0",
        },
        {
          name: "中国",
          value: "1",
        },
        {
          name: "中国香港",
          value: "3",
        },
        {
          name: "中国台湾",
          value: "2",
        },
        {
          name: "广东",
          value: "4",
        },
        {
          name: "日本",
          value: "5",
        },
        {
          name: "美国",
          value: "6",
        },
        {
          name: "菲律宾",
          value: "7",
        },
        {
          name: "韩国",
          value: "8",
        },
      ],
      selectYubaoType: "0",
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          title: "日期",
          key: "date",
          align: "center",
        },
        {
          title: "预报路径偏差(km)",
          key: "ybpc",
          align: "center",
        },
        {
          title: "压强偏差(hPa)",
          key: "pespc",
          align: "center",
        },
        {
          title: "风速偏差(m/s)",
          key: "windpc",
          align: "center",
        },
        {
          title: "对比经度",
          key: "lng",
          align: "center",
        },
        {
          title: "对比纬度",
          key: "lat",
          align: "center",
        },
        {
          title: "对比移动速度",
          key: "movespeed",
          align: "center",
        },
        {
          title: "对比风速",
          key: "speed",
          align: "center",
        },
        {
          title: "对比气压",
          key: "pressure",
          align: "center",
        },
        {
          title: "中大经度",
          key: "lng1",
          align: "center",
        },
        {
          title: "中大纬度",
          key: "lat1",
          align: "center",
        },
        {
          title: "中大移动速度",
          key: "movespeed1",
          align: "center",
        },
        {
          title: "中大风速",
          key: "speed1",
          align: "center",
        },
        {
          title: "中大气压",
          key: "pressure1",
          align: "center",
        },
      ],
      result: [],
      selectionData: [],
    };
  },
  mounted() {
    let t = this;
    for (let i = 0; i < 10; i++) {
      this.yearList.push(this.selectYear - i);
    }
    this.getTFBH(this.selectYear);
    setTimeout(function () {
      t.getData();
    }, 500);
  },
  watch: {},
  methods: {
    /**ajax请求数据  根据年份请求台风列表
     *@params year 年份
     **/
    getTFBH: function (year) {
      let t = this;
      //清除轨迹信息
      $.post(this.$ipConfig.getHisTyphoonData + "&starttime=" + year).then(
        (data2) => {
          if (data2.message === "查询成功") {
            t.typhoonList = data2.dataList;
            t.selectTyphoon = data2.dataList[0].tfid;
            t.getTyphoonTrack(t.selectTyphoon);
          } else {
            t.$Message.error({
              content: data.message,
              duration: 5,
            });
          }
        }
      );
    },
    /**查询中大预报信息**/
    getTyphoonTrack: function (tfbh) {
      let t = this;
      $.get(this.$ipConfig.getTypthoonZdybData + "&thisid=" + tfbh).then(
        (data) => {
          let array = [];
          t.trackData = [];
          data.dataList.map((item) => {
            if (array.indexOf(item.currentId) == -1) {
              t.trackData.push({ time: item.time, currentId: item.currentId });
              array.push(item.currentId);
            }
          });
          t.foreastingid = array[0];
        }
      );
    },
    changeYear() {
      this.getTFBH(this.selectYear);
    },
    changeTyphoon() {
      this.getTyphoonTrack(this.selectTyphoon);
    },
    remainRow(selection, row) {
      this.selectionData = selection;
    },
    exportTable() {
      this.$refs.analysisTable.exportCsv({
        filename: "误差分析",
        columns: this.columns.filter((col, index) => index > 0),
        data: this.result.filter((data, index) => {
          //filter() 方法创建一个新的数组，新数组中的元素是通过检查指定数组中符合条件的所有元//素。
          for (let i = 0; i < this.selectionData.length; i++) {
            //比较对象是否相等
            if (this.compareObject(data, this.selectionData[i])) {
              console.log("Burning Test" + i);
              return true;
            }
          }
          return false;
        }),
      });
    },
    //比较对象是否相等的方法
    compareObject(obj1, obj2) {
      //Object.getOwnPropertyNames():方法返回一个指定对象所有自身属性的属性名（包括不可枚举属性但不包括Symbol值作为名称的属性）组成的数组。
      //对象内置属性方法:Object.keys()；该方法返回一个数组，数组内包括对象内可枚举属性以及方法名称。数组中属性名的排列顺序和使用 for...in 遍历该对象时返回的顺序一致。
      var attrs1 = Object.keys(obj1);
      var attrs2 = Object.keys(obj2);
      if (attrs1.length != attrs2.length) {
        return false;
      }
      for (var j = 0; j < attrs1.length; j++) {
        var attrNames = attrs1[j];
        if (obj1[attrNames] != obj2[attrNames]) {
          return false;
        }
      }
      return true;
    },
    getData() {
      let t = this;
      if (this.selectYubaoType == "0") {
        $.get(
          this.$ipConfig.getTyphoonWC +
            "getTyphoonZdSKWC" +
            "&foreastingid=" +
            this.foreastingid +
            "&thisid=" +
            this.selectTyphoon
        ).then((data) => {
          data.dataList.map((item) => {
            item.date = moment(item.time).format("YYYY-MM-DD HH:mm:ss");
            item.ybpc = item.ybpc.toFixed(2);
          });
          t.result = data.dataList;
          setTimeout(function(){
            t.$refs.analysisTable.selectAll(true);
          },500)
        });
      } else {
        $.get(
          this.$ipConfig.getTyphoonWC +
            "getTythonZdWCFX" +
            "&foreastingid=" +
            this.foreastingid +
            "&releaseType=" +
            this.selectYubaoType
        ).then((data) => {
          data.dataList.map((item) => {
            item.date = moment(item.time).format("YYYY-MM-DD HH:mm:ss");
            item.ybpc = item.ybpc.toFixed(2);
          });
          t.result = data.dataList;
          setTimeout(function(){
            t.$refs.analysisTable.selectAll(true);
          },500)
        });
      }
    },
  },
};
</script>

<style scoped>
#item3 {
  width: 100%;
  height: 100%;
}
.layui-table-body {
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/common/errorAnalysis.vue